/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCircleMusic: {
  name: 'circle-music';
  data: string;
} = {
  name: 'circle-music',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm4.949 5.684a1 1 0 0 1-.633 1.265L14 9.72V14a3 3 0 1 1-2-2.83V9.72a2 2 0 0 1 1.367-1.897l2.317-.772a1 1 0 0 1 1.265.633ZM11 13a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z" fill="currentColor"/></svg>`,
};
